<!-- 日志查询 -->
<template>
  <div class="log-search">
    <div class="table-header">
      <a-form :layout="'horizontal'" class="page-search" :colon="true">
        <a-row :gutter="20">
          <a-col span="6">
            <a-form-item
              label="日志类型"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <SelectModule
                v-model="params.operateType"
                apiType="getDictDataByCode"
                :apiParams="{ dictCode: 'operate_type' }"
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="日志描述"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.bizDesc"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="操作人"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.operateUserAccount"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="所属机构"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.orgName"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="所属部门"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <InputText
                placeholder="请输入"
                v-model="params.departmentName"
                allowClear
              />
            </a-form-item>
          </a-col>
          <a-col span="6">
            <a-form-item
              label="操作时间"
              :label-col="formItemLayout.labelCol"
              :wrapper-col="formItemLayout.wrapperCol"
            >
              <a-range-picker
                format="YYYY-MM-DD HH:mm:ss"
                separator="~"
                allowClear
                :inputReadOnly="true"
                :value="dateValue"
                @change="onChange"
                :showTime="{
                  defaultValue: [
                    moment('00:00:00', 'HH:mm:ss'),
                    moment('23:59:59', 'HH:mm:ss'),
                  ],
                }"
                :getCalendarContainer="(trigger) => trigger.parentNode"
              >
              </a-range-picker>
            </a-form-item>
          </a-col>
          <a-col class="flag" span="6" :offset="6">
            <a-button @click="onReset"
              ><a-icon type="reload" style="color: #585d68" />重置</a-button
            >
            <a-button type="primary" @click="handleSearch"
              ><IconSvg iconData="search" />查询</a-button
            >
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-concent">
      <div class="concent-buts"></div>
      <TableList
        :columns="columns"
        :tableData="tableData"
        :loading="loading"
        :pageInfo="pageBean"
        @getList="changePage"
      >
      </TableList>
    </div>
  </div>
</template>

<script>
import InputText from "@/components/form/InputText"; // 输入框组件
import SelectModule from "@/components/form/SelectModule"; // 下拉组件
import TableList from "@/components/table/TableList"; // 表格组件
import LenovoSelectModule from "@/components/form/LenovoSelectModule"; // 联想下拉
import API from "@/api/logManage.js"; // 请求接口
import moment from "moment";
import { getNowDate } from "@/config/utils.js";

import "./index.less";

export default {
  components: {
    InputText,
    SelectModule,
    TableList,
    LenovoSelectModule,
  },
  computed: {
    columns() {
      const columns = [
        {
          title: "序号",
          dataIndex: "key",
          key: "key",
          width: 100,
          align: "center",
          fixed: "left",
          ellipsis: true,
          customRender: (text, row, index) => {
            return (
              (this.pageBean.pageNum - 1) * this.pageBean.pageSize + index + 1
            );
          },
        },
        {
          title: "日志类型",
          dataIndex: "operateTypeDesc",
          key: "operateTypeDesc",
          ellipsis: true,
        },
        {
          title: "日志描述",
          dataIndex: "bizDesc",
          key: "bizDesc",
          ellipsis: true,
          scopedSlots: { customRender: "bizDesc" },
        },
        {
          title: "操作人",
          dataIndex: "operateUserAccount",
          key: "operateUserAccount",
          ellipsis: true,
        },
        {
          title: "所属机构",
          dataIndex: "orgName",
          key: "orgName",
          ellipsis: true,
          scopedSlots: { customRender: "orgName" },
        },
        {
          title: "所属部门",
          dataIndex: "departmentName",
          key: "departmentName",
          width: 130,
          ellipsis: true,
          scopedSlots: { customRender: "departmentName" },
        },
        {
          title: "操作时间",
          dataIndex: "createTime",
          key: "createTime",
          width: 190,
          ellipsis: true,
        },
      ];
      return columns;
    },
  },
  data() {
    return {
      loading: false, // 是否加载
      pageBean: {
        // 自定义分页
        pageNum: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 0, // 数据总数
      },
      params: {
        operateType: "", // 类型，登录:L-字典(operate_type)
        orgName: "", // 机构id
        bizDesc: "", // 描述
        departmentName: "", // 部门
        operateUserAccount: "", // 操作人
        startDate: "",
        endDate: "",
      },
      dateValue: [], // 日期
      tableData: [], // 列表数据
      formItemLayout: {
        labelCol: {
          span: 6,
        },
        wrapperCol: {
          span: 18,
        },
      },
    };
  },
  mounted() {
    this.handleSearch();
    let currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 1);

    this.dateValue = [
      moment(
        moment(getNowDate(currentDate) + " " + "00:00:00").format(
          "YYYY-MM-DD HH:mm:ss"
        )
      ),
      moment(
        moment(getNowDate() + " " + "23:59:59").format("YYYY-MM-DD HH:mm:ss")
      ),
    ];
  },
  methods: {
    moment,
    onChange(date, dateString) {
      this.dateValue = dateString;
    },
    // 查询
    handleSearch() {
      this.getData(1);
    },
    // 获取列表数据
    getData(pageNum) {
      this.loading = true;
      let params = {
        data: {
          pageBean: {
            pageNum: pageNum,
            pageSize: this.pageBean.pageSize,
          },
          params: {
            ...this.params,
            startDate:
              this.dateValue && this.dateValue.length > 0
                ? this.dateValue[0]._i
                  ? this.dateValue[0]._i
                  : this.dateValue[0]
                : "",
            endDate:
              this.dateValue && this.dateValue.length > 0
                ? this.dateValue[1]._i
                  ? this.dateValue[1]._i
                  : this.dateValue[1]
                : "",
          },
        },
      };
      API.getAuditLogList(params, (callback) => {
        this.loading = false;
        let list = []; // 数据
        if (callback.status == "S" && callback.data) {
          const backData = callback.data;
          const pageBean = { ...this.pageBean };
          pageBean.total = backData.total || 0;
          pageBean.pageNum = pageNum || 1;
          this.pageBean = pageBean;

          if (Array.isArray(backData.list) && backData.list.length > 0) {
            backData.list.map((item, index) => {
              // item.key = item.id;
              item.key = index;
            });
            list = backData.list;
          }
          this.tableData = list;
        }
      });
    },
    // 分页事件
    changePage(page, filters, sorter) {
      this.pageBean.pageNum = page.current || 1;
      this.pageBean.pageSize = page.pageSize || 10;
      this.getData(this.pageBean.pageNum);
    },
    // 重置
    onReset() {
      this.params = {
        operateType: "", // 类型，登录:L-字典(operate_type)
        orgName: "", // 机构id
        bizDesc: "", // 登录账号
        departmentName: "", // 部门
        operateUserAccount: "", // 操作人
        startDate: "",
        endDate: "",
      };
      // this.dateValue = [];
      let currentDate = new Date();
      currentDate.setMonth(currentDate.getMonth() - 1);

      this.dateValue = [
        moment(
          moment(getNowDate(currentDate) + " " + "00:00:00").format(
            "YYYY-MM-DD HH:mm:ss"
          )
        ),
        moment(
          moment(getNowDate() + " " + "23:59:59").format("YYYY-MM-DD HH:mm:ss")
        ),
      ];
      this.handleSearch();
    },
  },
};
</script>
